import React from 'react';
import csrfToken from 'utils/csrfToken';

export function AuthenticityToken() {
  return <input type='hidden' name='authenticity_token' defaultValue={csrfToken()} />;
}

export default AuthenticityToken;
